export default axios => ({
  search(payload) {
    return axios.get('/user/search', payload);
  },
  list(payload) {
    return axios.get('/user/list', payload);
  },
  getActivityHistory(userId, payload) {
    return axios.get(`user/${userId}/appointment/list-group`, payload);
  },
  getQuestionnaire(userId, payload) {
    return axios.get(`user/${userId}/questionnaire-analytics`, payload);
  },
  update(payload, userId) {
    return axios.patch(`/user/${userId}/update/info`, payload);
  },
  getInfoList() {
    return axios.get('/user/info/list');
  },
  getQuestionnaireAnalytics(userId) {
    return axios.get(`user/${userId}/questionnaire-analytics`);
  },
  get(userId) {
    return axios.get(`user/${userId}/profile`);
  },
  appointment(userId, payload) {
    return axios.get(`/user/${userId}/appointment/list`, payload);
  },
  visits(userId, payload) {
    return axios.get(`/user/${userId}/visit/all`, payload);
  },

  create(payload) {
    return axios.post(`/user/create`, payload);
  },
  checkPhone(payload) {
    return axios.get(`/user/by/phone`, payload);
  }

})
